import React from 'react';
import { Grid } from '@mui/material';
import Button from '@mui/material/Button';
import { useNavigate } from "react-router-dom";
import UserProfile from '../../components/User';
import AccessController from '../../components/access_controller';

function StyledGrid(props) {
    const { children } = props;
    return (
        <Grid
            sx={{
                margin: '10px'
            }}
            item
        >
            {children}
        </Grid>
    )
}

export default function HomePage(props) {
    const navigate = useNavigate();
    const username = UserProfile.getName();
    const buttonStyle = { minWidth: '175px', minHeight: '60px', fontSize: '12px' };

    // Navigation handlers
    const goTo = (path) => () => navigate(path);

    // Button configs for left and right columns
    const leftButtons = [
        { label: "Fill Inventory", path: "/inventory/add/status", aria: "Fill Inventory" },
        { label: "Add Preparations", path: "/inventory/add/preparation", aria: "Add Preparations" },
        { label: "Add Usage", path: "/inventory/add/usage/", aria: "Add Usage", color: "error" },
        { label: "View Orders", path: "/orders/view", aria: "View Orders", color: "secondary" },
    ];
    const rightButtons = [
        { label: "Add Bill", path: "/bill/add/", aria: "Add Bill" },
        { label: "Add Wastage", path: "/inventory/add/wastage/", aria: "Add Wastage", color: "error" },
        { label: "View Bills", path: "/bill/view", aria: "View Bills" },
    ];

    return (
        <AccessController onlyAdmin={false}>
            <Grid
                container
                direction={'column'}
                alignItems="center"
                rowSpacing={1}
            >
                <Grid sx={{ margin: '10px', textAlign: 'center' }} item>
                    <h2>Store Management</h2>
                    <i>Welcome {username}</i>
                </Grid>
                <Grid item>
                    <Grid container spacing={2} justifyContent="center">
                        <Grid item xs={12} sm={6}>
                            <Grid container direction="column" alignItems="center" spacing={2}>
                                {leftButtons.map((btn) => (
                                    <Grid item key={btn.label}>
                                        <Button
                                            variant="contained"
                                            sx={buttonStyle}
                                            aria-label={btn.aria}
                                            color={btn.color || "primary"}
                                            fullWidth
                                            onClick={goTo(btn.path)}
                                        >
                                            <span>{btn.label}</span>
                                        </Button>
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Grid container direction="column" alignItems="center" spacing={2}>
                                {rightButtons.map((btn) => (
                                    <Grid item key={btn.label}>
                                        <Button
                                            variant="contained"
                                            sx={buttonStyle}
                                            aria-label={btn.aria}
                                            color={btn.color || "primary"}
                                            fullWidth
                                            onClick={goTo(btn.path)}
                                        >
                                            <span>{btn.label}</span>
                                        </Button>
                                    </Grid>
                                ))}
                                {UserProfile.isManager() && (
                                    <Grid item key="View Inventory">
                                        <Button
                                            variant="contained"
                                            sx={buttonStyle}
                                            aria-label="View Inventory"
                                            fullWidth
                                            onClick={goTo("/inventory/view")}
                                        >
                                            <span>View Inventory</span>
                                        </Button>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </AccessController>
    );
}